import React, { useContext, useState } from 'react';
import { Web3Context } from '../context/Web3Context';
import { useMutation, gql } from '@apollo/client';
import styled from 'styled-components';

const UPDATE_USER_MUTATION = gql`
  mutation UpdateUser($account: String!, $name: String!, $email: String!) {
    updateUser(account: $account, name: $name, email: $email) {
      id
      account
      name
      email
    }
  }
`;

// Styled components
const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 400px;
  margin: 20px auto;
  background: #fff;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const Input = styled.input`
  margin: 10px;
  padding: 10px;
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 5px;
`;

const Button = styled.button`
  padding: 10px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #0056b3;
  }
`;

const Error = styled.p`
  color: red;
`;

const UserUpdate = ({ showUpdate, setShowUpdate }) => {
    const { account, userInfo, setUserInfo } = useContext(Web3Context);
    const [updateUser, { loading }] = useMutation(UPDATE_USER_MUTATION);
    const [formError, setFormError] = useState('');

    const handleChange = (e) => {
        setUserInfo({
            ...userInfo,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate input
        if (userInfo.name.trim() === '' || userInfo.email.trim() === '') {
            setFormError('Name and Email cannot be empty.');
            return;
        }

        try {
            await updateUser({
                variables: {
                    account: account,
                    name: userInfo.name,
                    email: userInfo.email,
                },
            });
            setFormError(''); // Clear error if successful
            setShowUpdate(false); // Hide the form after successful update
        } catch (err) {
            // Check for the "Email already in use" error
            if (err.message.includes('Email already in use')) {
                setFormError('Email already in use. Please use a different email.');
            } else {
                setFormError('Error updating user information. Please try again.');
            }
        }
    };

    if (!showUpdate) return null;

    return (
        <ModalOverlay onClick={() => setShowUpdate(false)}>
            <Form onSubmit={handleSubmit} onClick={(e) => e.stopPropagation()}>
                <Input
                    type="text"
                    name="name"
                    value={userInfo.name || ''}
                    onChange={handleChange}
                    placeholder="Name"
                    required
                />
                <Input
                    type="email"
                    name="email"
                    value={userInfo.email || ''}
                    onChange={handleChange}
                    placeholder="Email"
                    required
                />
                <Button type="submit" disabled={loading}>
                    {loading ? 'Updating...' : 'Update Info'}
                </Button>
                {formError && <Error>{formError}</Error>}
            </Form>
        </ModalOverlay>
    );
};

export default UserUpdate;
